import { useCallback, useState } from 'react';

export const useGridApi = ({ onSelect = () => {}, selectedRowsProp }) => {
  const [gridApi, setGridApi] = useState(null);
  const [selectedRows, setSelectedRows] = useState(selectedRowsProp || []);

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
  }, []);

  const onSelectionChanged = useCallback(() => {
    if (!gridApi) return;
    const selectedNodes = gridApi.getSelectedNodes();
    setSelectedRows(selectedNodes);
    onSelect(selectedNodes);
  }, [gridApi, onSelect]);

  return { gridApi, onGridReady, selectedRows, setSelectedRows, onSelectionChanged };
};
